export const ADMIN_TEAM_ID = "e7a754dc-be5e-4598-adc2-376e25af0e91";
export const MANAGEMENT_TEAM_ID = "e720f47f-c580-4b46-9b67-46b34230d52f";
export const COMPANY_TYPE = {
    DIRECT_CUSTOMER: "DirectCustomer",
    PARTNER: "Partner"
}